var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input } from '@angular/core';
import { NavController, PopoverController } from 'ionic-angular';
import { ApiProvider } from '../../providers/api/api';
import { CommonProvider } from '../../providers/common/common';
var ShopFavoriteComponent = /** @class */ (function () {
    function ShopFavoriteComponent(navCtrl, apiProv, comProv, popoverCtrl) {
        this.navCtrl = navCtrl;
        this.apiProv = apiProv;
        this.comProv = comProv;
        this.popoverCtrl = popoverCtrl;
    }
    ShopFavoriteComponent.prototype.setFavorite = function () {
        var _this = this;
        if (!this.comProv.isLogin()) {
            this.comProv.alertLogin(this.navCtrl);
            return;
        }
        // 最大10件
        var shop_favorite_count = this.comProv.getOptionsValue('shop_favorite_count');
        var shop_favorite_limit = 5;
        var service_data = this.comProv.getService();
        if (service_data['option']['shop_favorite_limit'] != null) {
            shop_favorite_limit = service_data['option']['shop_favorite_limit'];
        }
        if (shop_favorite_count >= shop_favorite_limit) {
            this.comProv.dispAlert(shop_favorite_limit + '店舗までお気に入り登録が可能です。');
            return;
        }
        if (this.shop_data['is_click']) {
            return;
        }
        this.shop_data['is_click'] = true;
        this.apiProv.dispLoader();
        this.apiProv.post(this.shop_data['_links']['user_favorite_shop_store']['href'])
            .then(function (data) {
            _this.apiProv.removeLoader();
            _this.shop_data['is_click'] = false;
            if (data['statusCode'] != '000') {
                _this.apiProv.detaError(data);
                return;
            }
            _this.popFavorite();
            _this.shop_data['is_favorite'] = true;
            _this.comProv.setShopFavorite(_this.shop_data['id'], true);
            _this.comProv.setOptions('shop_favorite_count', shop_favorite_count + 1);
            // ホーム表示リセット
            _this.comProv.setOptions('is_home_coupon_cache', 0);
            _this.comProv.setOptions('is_home_event_cache', 0);
        }).catch(function (error) {
            _this.apiProv.removeLoader();
            _this.shop_data['is_click'] = false;
            _this.apiProv.statusError(error, _this.navCtrl);
        });
    };
    ShopFavoriteComponent.prototype.deleteFavorite = function () {
        var _this = this;
        if (!this.comProv.isLogin()) {
            this.comProv.alertLogin(this.navCtrl);
            return;
        }
        if (this.shop_data['is_click']) {
            return;
        }
        this.shop_data['is_click'] = true;
        this.apiProv.dispLoader();
        this.apiProv.delete(this.shop_data['_links']['user_favorite_shop_destroy']['href'])
            .then(function (data) {
            _this.apiProv.removeLoader();
            _this.shop_data['is_click'] = false;
            if (data['statusCode'] != '000') {
                _this.apiProv.detaError(data);
                return;
            }
            //this.popFavorite(false);
            _this.shop_data['is_favorite'] = false;
            _this.comProv.setShopFavorite(_this.shop_data['id'], false);
            var shop_favorite_count = _this.comProv.getOptionsValue('shop_favorite_count');
            if (shop_favorite_count > 0) {
                _this.comProv.setOptions('shop_favorite_count', shop_favorite_count - 1);
            }
            // ホーム表示リセット
            _this.comProv.setOptions('is_home_coupon_cache', 0);
            _this.comProv.setOptions('is_home_event_cache', 0);
        }).catch(function (error) {
            _this.apiProv.removeLoader();
            _this.shop_data['is_click'] = false;
            _this.apiProv.statusError(error, _this.navCtrl);
        });
    };
    ShopFavoriteComponent.prototype.popFavorite = function (is_set) {
        if (is_set === void 0) { is_set = true; }
        var popover = this.popoverCtrl.create('ShopSetPage', { is_set: is_set }, { cssClass: 'custom_popover', enableBackdropDismiss: false });
        popover.present();
    };
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], ShopFavoriteComponent.prototype, "shop_data", void 0);
    ShopFavoriteComponent = __decorate([
        Component({
            selector: 'shop-favorite',
            templateUrl: 'shop-favorite.html',
        }),
        __metadata("design:paramtypes", [NavController,
            ApiProvider,
            CommonProvider,
            PopoverController])
    ], ShopFavoriteComponent);
    return ShopFavoriteComponent;
}());
export { ShopFavoriteComponent };
//# sourceMappingURL=shop-favorite.js.map


// WEBPACK FOOTER //
// ./src/components/shop-favorite/shop-favorite.ts.pre-build-optimizer.js